import { getNpssUser, useIsNpssUser } from 'src/auth';

export const useIsSameAgency = (agency_id?: string | null) => {
  const isNpssUser = useIsNpssUser();
  if (isNpssUser && agency_id) {
    const npssUser = getNpssUser();
    return agency_id === npssUser?.agency_uuid;
  }
  return false;
};
